module.exports = __webpack_public_path__ + "static/media/arrow-down.b9c57ab3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/arrow-down.svg
// module id = 119
// module chunks = 0